<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="500px"
    >
      <v-btn class="w-close" icon
             @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="primary"
            class="w-button w-button-dialog"
            dark
            v-bind="attrs"
            v-on="on"
        >
          Зареєструвати код
        </v-btn>
      </template>
        <v-card>

          <div v-if="false">
            <div class="text-center"><span class="title secondary--text">Для участі в акції <br> Вам необхідно заповнити дані</span></div>

            <v-card-text>
              <v-form ref="form"
                      v-model="valid"
                      lazy-validation>
                <v-text-field
                    label="Ім'я"
                    outlined
                    color="secondary"
                    v-model="name"
                    autocomplete="off"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    label="Прізвище"
                    color="secondary"
                    outlined
                    v-model="last_name"
                    autocomplete="off"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    label="Номер телефону"
                    outlined
                    color="secondary"
                    :rules="[rules.required, rules.phone]"
                    v-mask="'+38(0##)-###-##-##'"
                    :masked="false"
                    placeholder="+38(0##)-###-##-##"
                    v-model="phone"
                ></v-text-field>
                <v-text-field
                    label="Код з чеку"
                    color="secondary"
                    outlined
                    v-model="checkNumber"
                ></v-text-field>


                <v-checkbox
                    class="mt-0"
                    color="secondary"
                    v-model="chech1"
                    :rules="[v => !!v || 'Вам потрібно погодитись, щоб продовжити']"
                    required
                    label="Мені вже виповнилось 18 років"
                >
                </v-checkbox>

                <v-checkbox
                    class="mt-0"
                    color="secondary"
                    v-model="chech2"
                    :rules="[v => !!v || 'Вам потрібно погодитись, щоб продовжити']"
                    required
                    label="Даю згоду на обробку персональних даних"
                >
                </v-checkbox>

                <v-checkbox
                    class="mt-0"
                    color="secondary"
                    v-model="privacy"
                    :rules="[v => !!v || 'Вам потрібно погодитись, щоб продовжити']"
                    required
                >
                  <template v-slot:label>
                    <div>
                      З офіційними &nbsp;<a target="_blank" @click.stop href="/file/Офіційні_правила_20_років_Наш_Край.pdf">правилами</a>&nbsp; акції погоджуюсь
                    </div>
                  </template>
                </v-checkbox>

                <div class="text-center mt-6">
                  <v-btn
                      color="secondary"
                      class="w-button w-button-dialog"
                      :disabled="comDisable"
                      @click="sendCode"
                      :loading="loading"
                  >
                    Надіслати
                  </v-btn>
                </div>

              </v-form>
            </v-card-text>
          </div>
          <div v-else>
            <div class="text-center"><h1>Акція завершена</h1></div>
          </div>


        </v-card>
    </v-dialog>
    <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialogSuccess"
    >
            <v-card>
              <v-card-text>
                <div class="text-h4 text-center pa-12">
                  <v-icon x-large color="error darken-2" v-if="iconDialogError">mdi-alert-decagram</v-icon>
                  <v-icon x-large color="green darken-2" v-else>mdi-alert-decagram</v-icon>
                  <br>
                  {{textDialog}}
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    text
                    @click="dialogSuccess = false"
                >Ок!</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  </div>

</template>

<script>
import {mask} from 'vue-the-mask'
import axios from 'axios'

export default {
  name: "Form",
  directives: {mask},
  data: () => ({
    dialog: false,
    valid: true,
    privacy: false,
    rules: {
      required: value => !!value || 'Обов`язкове',
      phone: value => {
        if (value) {
          if (value.length > 0 && value.length !== 18) {
            return 'Невірний номер телефону';
          }
        }
        return true;
      }
    },
    name: null,
    last_name: null,
    phone: null,
    checkNumber: null,
    dialogSuccess: false,
    textDialog: null,
    iconDialogError: false,
    chech1: false,
    chech2: false,
    loading: false
  }),
  watch: {
    dialog() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    }
  },
  methods: {

    sendCode () {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var params = new URLSearchParams();
        params.append('name', this.name);
        params.append('last_name', this.last_name);
        params.append('phone', this.phone);
        params.append('checkNumber', this.checkNumber);
        params.append('checkbox', this.privacy);

        axios.post('http://shop.nashkraj.ua/api/send-promo', params)
            .then(response => {
              // console.log(response.data);
                if (!response.data.success) {
                  this.iconDialogError = true;
                } else {
                  this.iconDialogError = false;
                  this.name = null
                  this.last_name = null
                  this.phone = null;
                  this.checkNumber = null;
                  this.privacy = false;
                  this.chech1 = false;
                  this.chech2 = false;
                  this.dialog = false;
                }
                this.textDialog = response.data.text;
                this.dialogSuccess = true;
                this.loading = false;
            })
            .catch(error => {
              alert(error);
            })
            .finally(() => {

            });
      }
    }
  },
  computed: {
    comDisable () {
        if (this.valid &&
            this.name &&
            this.phone &&
            this.last_name &&
            this.checkNumber &&
            this.chech1 &&
            this.chech2 &&
            this.privacy) {
          return false;
        }
        return true;
    }
  }
}
</script>

<style scoped>



.theme--light.v-card {
  background-color: #ffe0ab;
  font-style: italic;
  border: 2px solid #fff;
}

.w-close {
  position: absolute;
  z-index: 200;
  right: 0;
}




</style>